import { presetRoutes } from '@/router'
import { cloneDeep } from 'lodash-es'
import { defineStore } from 'pinia'
import { store } from '@/store'
import { apiGetMenus } from '@/api/login'
import { useCurrentUser } from '@/hooks/user'
import { flattenTree } from '@/utils/utils'
// import { flatMultiLevelRoutes } from '@/utils/routerHelper'
// import { getRoleTreeApi } from '@/api/menu'

export interface RouterModuleState {
  routers: AppRouteRecordRaw[]
  addRouters: AppRouteRecordRaw[]
}

export const useRouterStore = defineStore({
  id: 'router',
  state: (): RouterModuleState => ({
    routers: [], // 所有路由
    addRouters: [] // 除constant之外
  }),
  // persist: {
  //   enabled: true
  // },
  getters: {
    getRouters(): AppRouteRecordRaw[] {
      return this.routers
    },
    getAddRouters(): AppRouteRecordRaw[] {
      return cloneDeep(this.addRouters as AppRouteRecordRaw[])
    }
    // getFlatRouters(): AppRouteRecordRaw[] {
    //   return flatMultiLevelRoutes(cloneDeep(this.addRouters as AppRouteRecordRaw[]))
    // }
    // getIsAddRouters(): boolean {
    //   return this.isAddRouters
    // },
    // getHasAlarmRecord(): boolean {
    //   return this.hasAlarmRecord
    // }
  },
  actions: {
    // 根据menuId过滤路由
    filterRoutesByRole(): Promise<AppRouteRecordRaw[]> {
      return new Promise<AppRouteRecordRaw[]>(async resolve => {
        const res = await apiGetMenus()
        const menus = JSON.parse(res.menus || '[]')
        const user = useCurrentUser()
        user.setButtonPermissions(flattenTree(menus))  // 设置按钮权限
        const authPathList = this.getAuthPathArr(menus) //扁平的所有权限列表
        // 从前端静态路由过滤有权限的路由
        function filterRoutesByPath(routes, authPathList) {
          return cloneDeep(routes).filter(route => {
            const target = route.path.includes('/') ? route.path : `/${route.path}`
            if (authPathList.includes(target) || route.type === 'detail' || route.type === 'single-page') {
              if (route.children) {
                route.children = filterRoutesByPath(route.children, authPathList)
              }
              return true
            }
            return false
          })
        }
        const routes: AppRouteRecordRaw[] = filterRoutesByPath(presetRoutes, authPathList)
        resolve(routes)
      })
    },
    // 根据menuId过滤路由
    generateRoutes(): Promise<AppRouteRecordRaw[]> {
      return new Promise<AppRouteRecordRaw[]>(async resolve => {
        const filterRoutes = await this.filterRoutesByRole()
        this.addRouters = filterRoutes
        this.routers = this.addRouters.concat([
          {
            name: 'PathMatch',
            meta: {
              hidden: true,
              noCache: true
            },
            path: '/:pathMatch(.*)*',
            redirect: '/404'
          }
        ])
        resolve(this.routers)
      })
    },
    // 获取有权限的路由的path集合(目前只能用path标识唯一)
    getAuthPathArr(routes, res: string[] = []): string[] {
      routes.forEach(item => {
        res.push(item.path)
        if (item.children && item.children.length) {
          this.getAuthPathArr(item.children, res)
        }
      })
      return res
    }
  }
})

export const routerStoreWithOut = () => {
  return useRouterStore(store)
}
